"use client";

import { HeaderProvider } from "@/components/common";

type AppProvidersProps = {
  children?: React.ReactNode;
};

export const AppProviders = ({ children }: AppProvidersProps) => {
  return <HeaderProvider>{children}</HeaderProvider>;
};
